<template>
    <div>
        <h4 class="mb10">媒体素材</h4>
        <div v-if="type">
            <el-form :model="formInline" size="mini">
                <el-form-item label="">
                    <el-row :gutter="10">
                        <el-col :span="21">
                            <el-select v-model="formInline.plat_id" placeholder="先选择媒体" style="width: 100%;">
                                <el-option 
                                    v-for="item in platList"
                                    :key="item.id"
                                    :label="item.name" 
                                    :value="item.id"
                                />
                            </el-select>
                        </el-col>
                        <el-col :span="3"></el-col>
                    </el-row>
                    
                </el-form-item>
                <el-form-item label="">
                    <el-row :gutter="10">
                        <el-col :span="21"><el-input v-model="formInline.ad_id" placeholder="输入广告ID查询"></el-input></el-col>
                        <el-col :span="3"><el-button :loading="loading" type="primary" @click="onSubmit">查询</el-button></el-col>
                    </el-row>
                </el-form-item>
            </el-form>
        </div>

        <preview :info="info?.material_info"/>

        <div class="info_item">
            <h5 class="info_title">素材信息</h5>
            <div class="info_item_con">
                <div class="label">素材名称：</div>
                <div class="value">{{ info?.material_info?.material_name }}</div>
            </div>
            <div class="info_item_con">
                <div class="label">MD5：</div>
                <div class="value">{{ info?.material_info?.material_md5 }}</div>
            </div>

            <h5 class="info_title">投放信息</h5>
            <div class="info_item_con">
                <div class="label">媒体：</div>
                <div class="value">{{ info?.project_info?.plat_name }}</div>
            </div>
            <div class="info_item_con">
                <div class="label">账户ID：</div>
                <div class="value">{{ info?.project_info?.account_id }}</div>
            </div>
            <div class="info_item_con">
                <div class="label">广告ID：</div>
                <div class="value">{{ info?.project_info?.ad_id }}</div>
            </div>
            <div class="info_item_con">
                <div class="label">创建时间：</div>
                <div class="value">{{ info?.project_info?.create_time }}</div>
            </div>
            <div class="info_item_con">
                <div class="label">运营负责人：</div>
                <div class="value">{{ info?.project_info?.yy_user }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import preview from './preview.vue';
import { compareSearchPlatMd5Api, compareGetSearchListApi } from '@/api/systemTool/compare'

import {materialSelectModal} from '../modal'
export default {
    name: 'mediaInfo',
    components: {
        preview
    },
    props: {
        type: {
            type: Boolean,
            default: true
        },
        prewInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    watch: {
        prewInfo:{
            handler(){
                this.info = this.prewInfo
            },
            immediate:true,
            deep: true
        }
    },
    data() {
        return {
            formInline: {
                plat_id: '',
                ad_id: ''
            },
            loading: false,
            info:{},
            platList: []
        }
    },
    created() {
        this.getPlatList()
    },
    methods: {
        async getPlatList() {
            try {
                const { data } = await compareGetSearchListApi({search_type: 'plat'});
                this.platList = data.list;
            } catch (error) {
                this.$message.error('获取媒体失败')
            }
        },
        onSubmit() {
            this.loading = true
            compareSearchPlatMd5Api({plat_id:this.formInline.plat_id, ad_id: this.formInline.ad_id }).then(res => {
                let result = res.data.plat_material;
                if (!result.length) {
                    this.$message.error('未查询到相关素材')
                    return;
                }
                if(result && result.length === 1) {
                    this.info = result[0]
                    if(!this.info.material_info) return
                    this.$emit('getUrl', {...this.info.material_info, plat_id: this.info.project_info.plat_id})
                    return
                }

                const {vm} = materialSelectModal(
                    {
                        props: {
                            materialList: result
                        },
                        cbs:{
                            onSubmit:(data)=>{
                                if(!data.material_info) return
                                this.info = data
                                vm.close()
                                this.$emit('getUrl', {...this.info.material_info, plat_id: this.info.project_info.plat_id})
                            },
                        }
                    }
                )
            }, err => {
                this.$message.error(err.info)
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.info_item {
    padding: 0 6px;

    .info_title {
        margin-bottom: 10px;
    }

    .info_item_con {
        display: flex;
        align-items: flex-start;
        width: 100%;
        font-size: 12px;
        padding-bottom: 2px;
        padding-left: 12px;
        line-height: 22px;
        margin-bottom: 6px;

        .label {
            min-width: 64px;
            display: block;

        }

        .value {
            /*flex: 1;*/
            overflow-x: hidden;
            word-wrap: break-word;
            display: block;
            color: #333;
        }

        .overflowCon {
            overflow-x: auto;

            .overflowCon_a {
                //min-width: 250px;
                display: flex;
                flex-direction: column;

                a {
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>